export function downloadFile(path, options) {
  var link = document.createElement("a");
  link.href = path;

  link.target = options && options.target ? options.target : "default";

  link.download =
    options && options.name
      ? options.name
      : path.split("/").splice(-1)[0].split("?")[0];

  setTimeout(() => document.body.appendChild(link), 100);
  link.click();
}



// WEBPACK FOOTER //
// ./src/services/utils/downloadAudio.js